import { Check } from "lucide-react";

const SectionPositionnement = () => {
    const steps = [
        {
            title: "Formation",
            desc: "Tous niveaux, orienté impact",
            active: true,
        },
        {
            title: "Cas d’usage",
            desc: "Priorisés selon l’impact business",
            active: true,
        },
        {
            title: "Développement",
            desc: "Agents IA, application, automatisation",
            active: true,
        },
        {
            title: "Déploiement",
            desc: "Mise en production & accompagnement",
            active: false,
        },
    ];

    return (
        <section className="bg-[#0F1C2E] text-white py-20 px-6">
            <div className="container mx-auto grid lg:grid-cols-2 gap-16 items-center">
                <div>
                    <p className="text-sm text-accent uppercase before:content-[''] before:w-6 before:h-0.5 before:bg-accent/90 before:inline-block gap-4 flex items-center mb-4 before:animate-moveLine">
                        Notre positionnement
                    </p>
                    <h2 data-animate
                        className="text-4xl font-bold mb-6 leading-tight opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                    >
                        Un partenaire IA <br /> de bout en bout
                    </h2>
                    <p data-animate
                       className="text-gray-300 mb-8 leading-relaxed opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                        Contrairement aux acteurs traditionnels qui s’arrêtent à l’un des maillons,
                        NailixIA couvre l’intégralité de la chaîne — de la formation jusqu’à la mise en production.
                    </p>
                    <div className="space-y-4">
                        {[
                            "Nous ne nous arrêtons pas à la stratégie",
                            "Nous ne faisons pas que de la formation",
                            "Nous ne faisons pas que du développement",
                        ].map((text, index) => (
                            <div key={index} className="flex items-center gap-3">
                                <div data-animate
                                     className="w-6 h-6 flex items-center justify-center rounded-full bg-accent/20 text-accent opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0"
                                >
                                    <Check size={16} />
                                </div>
                                <p data-animate className="text-gray-200 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="relative">
                    <div className="absolute left-4 top-0 bottom-0 w-[2px] bg-white/10"></div>
                    <div className="space-y-8">
                        {steps.map((step, index) => (
                            <div key={index} className="relative flex items-start gap-6">
                                <div data-animate
                                     className={`w-3 h-3 mt-2 rounded-full opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0 ${
                                    step.active ? "bg-accent" : "bg-white/20"
                                }`}></div>
                                <div
                                    className={`flex-1 p-5 rounded-xl border transition ${
                                        step.active
                                            ? "bg-[#13263F] border-accent/40"
                                            : "bg-[#1A2A44] border-white/10 opacity-70"
                                    }`}
                                >
                                    <p data-animate className={`text-sm font-semibold opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0 ${
                                        step.active ? "text-accent" : "text-gray-400"
                                    }`}>
                                        {`0${index + 1} — ${step.title}`}
                                    </p>

                                    <p data-animate className="text-gray-300 text-sm mt-1 opacity-0 translate-y-6 transition-all duration-700 ease-out data-[visible=true]:opacity-100 data-[visible=true]:translate-y-0">
                                        {step.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SectionPositionnement;
